/** The branch a kiosk design is drawn and previewed for: the first preference that
 *  is one of these branches, else the first branch offering a service, else the first. */
export function pickBranch(
  branches: ReadonlyArray<{ id: string }>,
  offered: Readonly<Record<string, ReadonlyArray<{ active: boolean }> | undefined>>,
  ...preferred: Array<string | null | undefined>
): string | undefined {
  const ids = new Set(branches.map((b) => b.id))
  for (const p of preferred) if (p && ids.has(p)) return p
  return branches.find((b) => offered[b.id]?.some((s) => s.active))?.id ?? branches[0]?.id
}
